export const getResponsiveSliceConfig = (width) => {
  if (width >= 1451 && width < 1600) {
    return { MRN: 8, "Episode ID": 8, Status: 12, Specialty: 8 };
  } else if (width >= 1600 && width < 1750) {
    return { MRN: 12, "Episode ID": 12, Status: 16, Specialty: 12 };
  } else if (width >= 1750&& width < 1900) {
    return { MRN: 15, "Episode ID": 15, Status: 20, Specialty: 15 };
  }  else if (width >= 1900 && width < 2100) {
    return { MRN: 20, "Episode ID": 20, Status: 25, Specialty: 20 };
  }
  else if (width >= 2100 && width < 2400) {
    return { MRN: 26, "Episode ID": 26, Status: 38, Specialty: 20 };
  } else if (width >= 2400 && width < 2500) {
    return { MRN: 26, "Episode ID": 26, Status: 50, Specialty: 20 };
  } else if (width >= 2500 && width <= 2999) {
    return { MRN: 30, "Episode ID": 30, Status: 50, Specialty: 24 };
  } else if (width >= 2999) {
    // For ultra-wide monitors (no slice or very large)
    return { MRN: 50, "Episode ID": 50, Status: 50, Specialty: 50 };
  } else {
    // fallback (small screens)
    return { MRN: 4, "Episode ID": 4, Status: 4, Specialty: 4 };
  }
};